import React from 'react';
import PropTypes from 'prop-types';
import { Info } from 'components/SvgIcons';
import { CFM_METAL } from 'constants/Colors';
import Button from '../Button';
import './styles.scss';

const ButtonInfo = ({ classNames = [], ...props }) => (
    <Button {...props} classNames={['custom-btn-info', ...classNames]}>
        <Info color={CFM_METAL} />
    </Button>
);

ButtonInfo.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
};

export default ButtonInfo;
